// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var storeManageRouter = {
  path: '/storeManage',
  component: Layout,
  redirect: '/storeManage/index',
  name: 'StoreManage',
  meta: {
    title: '门店',
    icon: 'component'
  },
  children: [{
    path: 'index',
    hidden: true,
    component: function component() {
      return import('@/views/storeManage/index.vue');
    },
    name: 'StoreManage',
    meta: {
      title: '门店管理',
      icon: ''
    }
  }, {
    path: 'form/index',
    hidden: true,
    component: function component() {
      return import('@/views/storeManage/form/index.vue');
    },
    name: 'StoreManageForm',
    meta: {
      title: '门店新增/修改',
      icon: '',
      activeMenu: "/storeManage/index"
    }
  }, {
    path: 'staff/index',
    hidden: true,
    component: function component() {
      return import('@/views/storeManage/staff/index.vue');
    },
    name: 'StoreStaff',
    meta: {
      title: '门店员工管理',
      icon: '',
      activeMenu: "/storeManage/index"
    }
  }, {
    path: 'staff/form/index',
    hidden: true,
    component: function component() {
      return import('@/views/storeManage/staff/form/index.vue');
    },
    name: 'StoreStaffForm',
    meta: {
      title: '门店员工新增/修改',
      icon: '',
      activeMenu: "/storeManage/index"
    }
  }, {
    path: 'verifyLog/index',
    hidden: true,
    component: function component() {
      return import('@/views/storeManage/verifyLog/index.vue');
    },
    name: 'StoreStaffVerifyLog',
    meta: {
      title: '核销记录',
      icon: '',
      activeMenu: "/storeManage/verifyLog/index"
    }
  }, {
    path: 'comment',
    component: function component() {
      return import('@/views/storeManage/comment/index.vue');
    },
    name: 'StoreComment',
    meta: {
      title: '评论管理',
      icon: '',
      activeMenu: "/storeManage/comment"
    }
  }]
};
export default storeManageRouter;